module.exports = __webpack_public_path__ + "static/media/hand-up-nor.7fb3162a.png";